<template>
    <div v-if="show">
        <v-alert
            border="top"
            colored-border
            :type="type"
            elevation="2"
            dismissible
        >
            {{ msg }}
        </v-alert>
    </div>
</template>
<script>
export default {
    name: 'DynamicAlerts',
    props: {
        msg: {
            type: String,
            default: ''
        },
        type: {
            type: String,
            default: 'info'
        },
        show: {
            type: Boolean,
            default: false
        }
    }
}
</script>
